// src/components/BookPromoSection.js (CORREGIDO)

import React from 'react';
import { useNavigate } from 'react-router-dom'; // <--- CAMBIO CRÍTICO: Importación de Router
import './BookPromoSection.css'; 
// 🛑 Importación del GIF 
import libroGif from '../assets/images/libro-promo.gif'; 

// Eliminamos la prop setActivePage
const BookPromoSection = () => {
    const navigate = useNavigate(); // <--- INICIALIZACIÓN

    return (
        <section id="book-promo" className="section book-promo-container gif-background">
            <div className="book-promo-content">
                
                {/* Usa el GIF */}
                <img 
                    src={libroGif} 
                    alt="Los Secretos del Derecho Mercantil - Dr. Giovanni Scarvaci" 
                    className="book-cover-image" 
                />
                
                <div className="book-info">
                    <h2>"Los Secretos del Derecho Mercantil"</h2>
                    <p>Una fuente de consulta útil para abogados, profesores y estudiantes de Derecho, litigantes, profesionales vinculados al sector comercial, comerciantes y público en general. De fácil lectura y comprensión.</p>
                    
                    <button 
                        className="cta-button primary" 
                        // 🚀 CORREGIDO: Navega a /libro para coincidir con App.js
                        onClick={() => navigate('/libros')} // Envíalo al catálogo para que vea todos los libros disponibles
                    >
                        Comprar Libro Digital
                    </button>
                </div>
            </div>
        </section>
    );
};

export default BookPromoSection;